export enum GridTabNames {
  live = 'Live Bids',
  won = 'Bids Won',
  lost = 'Bids Lost',
  unsubmitted = 'Unsubmitted'
}

export enum GridTabValue {
  live = 'live',
  won = 'won',
  lost = 'lost', 
  unsubmitted = 'unsubmitted'
}